import { coworkingsConstants } from '../redux-constants'
import { findIndex } from 'lodash'

const initialState = {
    list: [],
    error: null,
    loading: false,
    checkCoworkings: false,
    result: null,
    activeFilters: [],
}

export default function coworking(state = initialState, action) {
    switch (action.type) {
        case coworkingsConstants.LOADING_COWORKINGS_REQUEST:
            state.loading = true
            state.error = null
            state.activeFilters = { ...state.activeFilters, ...action.payload }
            state.checkCoworkings = false
            return state

        case coworkingsConstants.LOADING_COWORKINGS_FAILURE:
            state.loading = false
            state.error = action.payload
            state.checkCoworkings = true
            return state

        case coworkingsConstants.LOADING_COWORKINGS_DONE:
            state.loading = false
            state.checkCoworkings = true
            return state

        case coworkingsConstants.AJAX_CALL_REQUEST:
            state.loading = true
            state.error = null
            return state

        case coworkingsConstants.AJAX_CALL_FAILURE:
            state.error = action.payload
            state.loading = false
            state.checkCoworkings = true
            return state

        case coworkingsConstants.AJAX_CALL_SUCCESS:
            state.loading = false
            state.checkCoworkings = true
            state.result = action.payload
            return state

        case coworkingsConstants.ADD_ITEMS:
            state.list = action.payload
            return state

        case coworkingsConstants.FETCH:
            state.list = !state.list.length
                ? state.list.concat(...action.payload)
                : findIndex(state.list, {
                      id: action.payload.id,
                  }) === -1
                ? state.list.concat(action.payload)
                : state.list.map(item => {
                      return item.id === action.payload.id
                          ? action.payload
                          : item
                  })
            state.loading = false
            state.checkCoworkings = true
            return state

        case coworkingsConstants.UPDATE_COWORKINGS:
            const cowoIndex = state.list.findIndex(
                x => x.id === action.payload.id
            )
            state.list =
                cowoIndex === -1
                    ? state.list.concat(action.payload)
                    : state.list.map(item => {
                          return item.id === action.payload.id
                              ? {
                                    ...action.payload,
                                }
                              : item
                      })
            state.loading = false
            return state

        default:
            return state
    }
}
